import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { TemplateBodyPreview } from "@tellescope/templates";
import { useTranslation } from "react-i18next";

export interface InboxTemplateSelectorPreviewProps {
  template: TellescopeModelFromName<"templates"> | undefined;
}

export const InboxTemplateSelectorPreview = ({ template }: InboxTemplateSelectorPreviewProps) => {
  const { t } = useTranslation("messaging");

  if (!template) {
    return (
      <div className="flex items-center justify-center h-full text-sm text-muted-foreground">
        {t("Select a template to preview it")}
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="px-4 py-3 border-b space-y-1">
        <p className="text-sm font-semibold">{template.title}</p>
        {!!template.subject && <p className="text-xs text-muted-foreground">{template.subject}</p>}
      </div>
      {/* The preview surface is the only scroll container — a scrolling wrapper around it would
          double the scrollbars, since the HTML preview's iframe sizes itself to its content. */}
      <div className="flex min-h-0 flex-1 flex-col bg-white">
        <TemplateBodyPreview
          html={template.html}
          message={template.message}
          mode={template.mode}
          className="min-h-0 flex-1 p-3"
        />
      </div>
    </div>
  );
};
